<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="apiUrl"
      :delete-content="true"
      :block-content="false"
      :edit-content="true"
      :edit-component="editComponent"
      :view-content="false"
      :columns="columns"
      :type="type"
      :top-header="topHeader"
    >
      <template #cell(user)="data">
        <div class="d-flex py-1">
          <div style="margin-right:10px ;">
            <b-avatar size="40" />
          </div>
          <div class="d-flex flex-column justify-content-start align-items-start">
            <span>{{ data.item.user.name }}</span>
            <span class="text-muted">{{ data.item.user.email }}</span>
          </div>
        </div>
      </template>

      <template #cell(office_manager_action_at)="data">
        <span>
          {{ formatDate(data.item.office_manager_action_at) }}
        </span>
      </template>
      <template #cell(hr_action_at)="data">
        <span>
          {{ formatDate(data.item.hr_action_at) }}
        </span>
      </template>
      <template #cell(due_on)="data">
        <span>
          {{ formatDate(data.item.due_on) }}
        </span>
      </template>
      <template #cell(issued_on)="data">
        <span>
          {{ formatDate(data.item.issued_on) }}
        </span>
      </template>
      <template #cell(payment_status)="data">
        <b-badge :variant="data.item.payment_status === 'paid' ? 'success' : 'danger'">
          {{ data.item.payment_status }}</b-badge>
      </template>
      <template #cell(status)="data">
        <b-badge :variant="statusColor(data.item.status).color">
          <feather-icon
            :icon="statusColor(data.item.status).icon"
          />
          {{ statusColor(data.item.status).text }}
        </b-badge>
      </template>
      <template #cell(action)="data">
        <div class="d-flex justify-content-center">

          <div v-if="data.item.status === 'pending' || data.item.status === 'office_manager_approved'">
            <b-btn
              size="sm"
              variant="outline-success"
              class="mr-1 onhoverBtn"
              @click="approve(data.item.id, data.item.status)"
            >
              Approve
            </b-btn>
            <b-btn
              size="sm"
              variant="outline-danger"
              class="onhoverBtn"
              @click="reject(data.item.id, data.item.status)"
            >
              Reject
            </b-btn>
          </div>
        </div>
      </template>
    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import formatDate from '@/global-compositions/formatDate'
import decryptData from '@/store/auth/decryptData'

export default {
  components: { GeneralTable },
  data() {
    return {
      viewContent: true,
      hoveredId: null,
      type: 'page',
      editComponent: 'edit-loan',
      filter: {},
      columns: [
        { key: 'status', label: '' },
        { key: 'user', label: 'user' },
        { key: 'office_manager_action_at', label: 'At' },
        { key: 'office_manager_action_by', label: 'By' },
        { key: 'office_manager_remark', label: 'Remark' },
        { key: 'hr_action_at', label: 'At' },
        { key: 'hr_action_by', label: 'By' },
        { key: 'hr_remark', label: 'Remark' },
        { key: 'due_on', label: 'Due' },
        { key: 'issued_on', label: 'Issued' },
        { key: 'payment_months', label: 'Months' },
        { key: 'payment_status', label: 'Status' },
        { key: 'note', label: 'Note' },
        { key: 'amount', label: 'Amount' },
        { key: 'remaining_amount', label: 'Remaining' },
        { key: 'action', label: '' },
        { key: 'actions', label: '' },
      ],
      topHeader: [
        { lable: 'Status', colspan: 1 },
        { lable: 'User', colspan: 1 },
        { lable: 'Office Manager', colspan: 3 },
        { lable: 'HR', colspan: 3 },
        { lable: 'Dates', colspan: 2 },
        { lable: 'payment', colspan: 3 },
        { lable: 'Amount', colspan: 2 },
        { lable: 'actions', colspan: 2 },
      ],
    }
  },

  computed: {

    apiUrl() {
      let base = 'loan?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },
  mounted() {
  },

  methods: {
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },
    formatDate(date) {
      return formatDate(date)
    },
    statusColor(data) {
      switch (data) {
        case 'office_manager_approved':
          return { color: 'success', text: 'OM Approved', icon: 'CheckCircleIcon' }
        case 'office_manager_rejected':
          return { color: 'danger', text: 'OM Rejected', icon: 'XCircleIcon' }
        case 'hr_approved':
          return { color: 'success', text: 'HR Approved', icon: 'CheckCircleIcon' }
        case 'hr_rejected':
          return { color: 'danger', text: 'HR Rejected', icon: 'XCircleIcon' }
        default:
          return { color: 'primary', text: 'pending', icon: 'MoreVerticalIcon' }
      }
    },
    approve(id, type) {
      this.$swal({
        title: 'Are you sure you want to Approve?',
        input: 'textarea', // 👈 input field for remark
        inputPlaceholder: 'Enter your remark (optional)',
        inputAttributes: {
          'aria-label': 'Enter your remark',
        },
        width: 600,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: remark => {
          if (!remark) {
            return '' // allow empty remarks if not entered
          }
          return remark
        },
      }).then(result => {
        if (result.isConfirmed) {
          let apiUrl = ''
          if (type === 'pending') {
            apiUrl = `loan/${id}/office-manager-approval`
          } else {
            apiUrl = `loan/${id}/hr-approval`
          }

          axios.put(apiUrl, {
            action: 'approve',
            remark: result.value || '', // 👈 send remark here
          })
            .then(() => {
              this.$toast.success('Approved Successfully!')
              this.$refs.generalTable.getAllData(1)
            })
            .catch(error => {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            })
        }
      })
    },

    reject(id, type) {
      this.$swal({
        title: 'Are you sure you want to reject?',
        input: 'textarea', // 👈 input field for remark
        inputPlaceholder: 'Enter your remark (optional)',
        inputAttributes: {
          'aria-label': 'Enter your remark',
        },
        width: 600,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: remark => {
          if (!remark) {
            return '' // allow empty remarks if not entered
          }
          return remark
        },
      }).then(result => {
        if (result.isConfirmed) {
          let apiUrl = ''
          if (type === 'pending') {
            apiUrl = `loan/${id}/office-manager-approval`
          } else {
            apiUrl = `loan/${id}/hr-approval`
          }

          axios.put(apiUrl, {
            action: 'reject',
            remark: result.value || '', // 👈 send remark here
          })
            .then(() => {
              this.$toast.success('Rejected Successfully!')
              this.$refs.generalTable.getAllData(1)
            })
            .catch(error => {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            })
        }
      })
    },

  },
}
</script>

<style>
.onhoverBtn:hover {
  color: white !important;
  border: 1px solid white !important;
  background-color: transparent !important;
}
</style>
